export default {
  appName: "Zeus BPM",
  actions: {
    search: "検索",
    clear: "条件をクリア",
    retry: "再試行",
    cancel: "キャンセル",
    save: "保存",
    submit: "送信",
    close: "閉じる",
  },
  /** 操作が通ったことを知らせるトースト（`lib/notify.ts`）。 */
  toast: {
    submitted: "提出しました",
    applicationStarted: "起票しました",
    draftCreated: "下書きを作成しました",
    decided: "判定を送信しました",
    bulkApproved: "{{count}} 件を承認しました",
    saved: "保存しました",
    fileCreated: "{{name}} を作成しました",
    secretSaved: "鍵を保存しました",
    secretRemoved: "鍵を削除しました",
    modelCreated: "「{{name}}」を作成しました",
    modelDeleted: "「{{name}}」を削除しました",
    groupDeleted: "グループ「{{name}}」を削除しました",
    diagramReplaced: "図を差し替えました",
    formFilesImported: "フォーム定義を {{count}} 件取り込みました",
  },
  state: {
    loading: "読み込み中",
    empty: "データがありません",
    error: "読み込みに失敗しました",
  },
  pagination: {
    previous: "前へ",
    next: "次へ",
    page: "ページ",
    perPage: "表示件数",
    total: "{{count}} 件",
    totalFiltered: "{{count}} 件（このページ内で絞り込み）",
    totalAtLeast: "{{count}} 件以上",
  },
  myApplications: {
    selfInitiator: "自分",
    scopeMine: "自分の起票",
    scopeInvolved: "関与した案件",
    scopeLabel: "対象範囲",
    actionRequired: "要対応",
    actionRequiredDescription: "あなたの操作で進む案件です。",
    showMoreActionRequired: "他 {{count}} 件を表示",
    showLessActionRequired: "表示を減らす",
    editDraft: "編集して提出",
    fixAndResubmit: "修正して再提出",
    allApplications: "すべての案件",
    filters: {
      keyword: "件名で検索",
      status: "ステータス",
      period: "起票日",
      allStatuses: "すべて",
    },
  },
  secrets: {
    title: "Secrets・認証連携",
    description: "BPM が外部システムを叩くための鍵を管理します。",
    scopeNote:
      "ここは「BPM が外部を叩くための鍵」専用です。ユーザーのログイン認証は Zeus IdP が担います。値はフロー定義に直書きせず、Service Task から SPIFF_SECRET:キー名 で参照します。",
    key: "キー",
    value: "値",
    owner: "登録者",
    updatedAt: "更新日時",
    hidden: "（表示されません）",
    add: "鍵を追加",
    update: "更新",
    remove: "削除",
    empty: "登録された鍵はありません",
    valuePrompt: "値を入力してください",
    keyPrompt: "キー名を入力してください",
    authentications: "OAuth 連携",
    noAuthentications: "OAuth 連携が必要な接続はありません",
  },
  formDesign: {
    title: "フォーム設計",
    description: "ヒューマンタスクの入力フォーム（JSON Schema）を確認します。",
    files: "フォーム定義",
    fields: "入力項目",
    preview: "プレビュー",
    raw: "スキーマ",
    required: "必須",
    choices: "選択肢",
    selectFile: "フォームを選ぶと内容を表示します",
    empty: "フォーム定義がありません",
    notForm:
      "このファイルは入力項目を持ちません（UI Schema などの補助ファイル）。",
    edit: "編集",
    cancelEdit: "編集をやめる",
    editorLabel: "フォーム定義（JSON）",
    editHint:
      "保存するとサーバ上のフォーム定義が更新されます（リポジトリへの反映は別途コミットが必要）。",
    issueEmpty: "内容が空です",
    issueInvalidJson: "JSON として読み取れません",
    issueNotObject: "オブジェクト（{}）で書いてください",
    issueInvalidProperties: "properties はオブジェクトで書いてください",
    issueInvalidRequired: "required は配列で書いてください",
    issueUnknownRequired:
      "required の「{{detail}}」が properties にありません（入力できないフォームになります）",
  },
  processDesign: {
    newModel: {
      open: "新規モデル作成",
      title: "新規モデルの作成",
      source: "作り方",
      sourceStarter: "雛形から作る（起案タスク 1 つ）",
      sourceFile: "手持ちの .bpmn から作る",
      group: "グループ",
      groupPlaceholder: "グループを選んでください",
      groupNew: "＋ 新しいグループを作る",
      groupId: "グループ id",
      groupIdHint: "英小文字・数字・ハイフン（ディレクトリ名になる。例: hr）",
      groupDisplayName: "グループの表示名",
      modelName: "モデル名",
      modelNameHint:
        "英小文字・数字・ハイフン（ディレクトリ名になる。例: interview-request）",
      displayName: "表示名",
      filledFromFileName: "ファイル名から入れました",
      filledFromProcessName: "図のプロセス名から入れました",
      invalidId: "英小文字・数字・ハイフンで入力してください。",
      duplicateId: "同じ id が既にあります。",
      submit: "作成",
      cancel: "やめる",
      failed: "モデルを作成できませんでした。",
      failedDuplicate: "同じ id のモデルが既にあります。",
      failedGroupDuplicate: "グループ id「{{id}}」は既にあります。",
      failedFileInvalid: "BPMN を受け付けられませんでした: {{detail}}",
      failedForbidden: "作成する権限がありません。",
      failedGroupMissing: "グループ「{{id}}」が存在しません。",
      groupKept:
        "グループ「{{name}}」（{{id}}）は作成しました。グループ欄はそのグループに切り替えてあります。",
      rolledBack:
        "ファイル（BPMN・起案フォーム）を追加できなかったため、作りかけのモデルは削除しました。",
      retry: "もう一度「作成」を押してください。",
      leftover:
        "ファイル（BPMN・起案フォーム）を追加できませんでした。作りかけのモデル（{{id}}）が残っています。開いて削除してください。",
      groupOption: "{{id}}（{{name}}）",
      groupsUnavailable:
        "グループ一覧を取得できませんでした。モデルの無いグループは候補に出ません。",
      previewFailed:
        "この図は画面に表示できません（レイアウト情報が無いか壊れています）。このまま作るとこの画面で表示も編集もできないため、別のファイルを選んでください。",
      openLeftover: "そのモデルを開く",
      note: "起案タスク 1 つの雛形を作ります。件名の項目（case_title）は自動で入ります。続きはこの画面で編集してください。",
      noteFile:
        "選んだ .bpmn をそのまま置きます（ファイル名はモデル名に合わせます）。起案フォームは作りません。件名は、図の中で case_title という変数に値を入れたときに一覧へ出ます（フォームの項目名を case_title にする、など）。",
    },
    newForm: {
      open: "フォームを追加",
      fileName: "ファイル名",
      fileNameHint:
        "英小文字とハイフン。項目を定義するなら *-schema.json、並び順なら *-uischema.json（区切りは . も可。例: review-schema.json / review.schema.json）",
      empty: "このモデルにはフォーム定義がありません。",
      failed: "フォーム定義を作成できませんでした（権限がありません）。",
      issueEmpty: "ファイル名を入力してください。",
      issueInvalid:
        "使えない文字が含まれています（英小文字・数字・ハイフンのみ）。",
      issueConvention:
        "*-schema.json または *-uischema.json で終わる名前にしてください（.schema.json / .uischema.json も可）。",
      issueDuplicate: "同じ名前のファイルが既にあります。",
    },
    title: "プロセス設計",
    description: "承認フローの定義（プロセスモデル）を作成・確認・編集します。",
    readme: {
      title: "モデルの説明",
      edit: "説明を編集",
      create: "説明を作成",
      save: "説明を保存",
      cancel: "やめる",
      label: "説明（Markdown）",
      empty: "このモデルには説明がありません。",
      saveFailed: "説明を保存できませんでした。",
      conflict: "他の人が更新しています。内容を控えてから読み直してください。",
      loadFromFile: "ファイルから読み込む",
      fileLabel: "説明のファイル",
      fileHint:
        ".md を 1 つ選べます。中身を下の編集欄に入れます（確定は「説明を保存」）。",
      notMarkdown: ".md ファイルを選んでください。",
    },
    metadata: {
      title: "案件に出す項目",
      description:
        "選んだ項目が案件の一覧・詳細に出ます（宣言しないと、入力されていても表示されません）。反映はこれ以降に起票された案件からです。",
      save: "出す項目を保存",
      saveFailed: "保存できませんでした。",
    },
    diagramTitle: "フロー図（編集できます）",
    models: "プロセスモデル",
    searchModels: "モデルを検索",
    noMatch: "該当するモデルがありません。",
    primaryProcess: "実行プロセス",
    diagrams: "フロー図",
    forms: "フォーム定義",
    others: "その他のファイル",
    selectModel: "モデルを選ぶと内容を表示します",
    editNote:
      "この画面で作成・編集・削除できます。変更はサーバ上のモデルに反映されます。恒久化するには書き出したファイルを process-models/ にコミットし、反映は deploy-models.sh（GitOps）を使います。",
    edit: "図を編集",
    backToView: "閲覧に戻す",
    exportHint:
      "保存するとサーバ上のモデルが更新されます（リポジトリへの反映は別途コミットが必要）",
    download: "書き出し",
    saved: "保存しました",
    saveFailed: "保存に失敗しました",
    saveConflict:
      "他の人がこのファイルを更新しています。書き出して差分を確認してください",
    properties: {
      title: "要素の設定",
      selectElement: "要素を選ぶと設定を編集できます",
      name: "名称",
      instructionsForEndUser: "利用者向けの説明",
      preScript: "実行前スクリプト",
      postScript: "完了後スクリプト",
      operator: "オペレータ",
      resultVariable: "結果を入れる変数",
      parameters: "パラメータ",
      parameterValue: "{{name}} の値",
      taskProperties: "タスクの設定（properties）",
      messageStart: "メッセージ起票",
      messageStartHint:
        "この開始イベントはメッセージ開始イベントではありません。図の変換メニュー（レンチ）で Message Start Event に変えると設定できます。",
      messageName: "メッセージ名",
      messageVariable: "payload の受け取り変数",
      messageNameRequired:
        "メッセージ名が空です。このままでは起票時のデータ（承認者など）が渡りません。",
      messageNameTaken:
        "このメッセージ名は {{model}} が使っています。保存できないので別の名前にしてください。",
      script: "スクリプト",
      scriptEmpty:
        "スクリプトが空です。このタスクは何もしません（メッセージ起票なら payload の展開をここに書きます）。",
      formSchema: "フォーム定義",
      formUiSchema: "UI Schema",
      formNone: "（なし）",
      formRequired:
        "フォームが未設定です。このタスクは開けません（担当者に「開けません」と表示されます）。",
      structuredNote:
        "外部呼び出しの追加・削除やパラメータの新設は SpiffArena 標準UI（:8001）で行ってください。ここでは既存の値を書き換えられます。",
    },
    empty: "プロセスモデルがありません",
    fileDrop: {
      placeholder: "クリックして選ぶか、ここにドロップ",
      clear: "選んだファイルを外す",
      unreadable: "ファイルを読めませんでした。",
    },
    bpmnFile: {
      label: "BPMN ファイル",
      hint: ".bpmn を 1 つ選べます。",
      preview: "図のプレビュー",
      notBpmn: ".bpmn ファイルを選んでください。",
      invalidXml: "BPMN ファイルとして読めません。",
      noExecutableProcess:
        '実行できるプロセスが見つかりません（プロセスが無いか、すべて isExecutable="false" になっています）。',
      multipleExecutableProcesses:
        "実行できるプロセスが複数あります（{{ids}}）。1 つにしてください。",
      idSeparator: "、",
    },
    importDiagram: {
      open: "取り込み",
      title: "図の取り込み",
      description:
        "今の図（{{file}}）を、選んだファイルの内容で置き換えます。ファイル名は変わりません。元の図は画面からは戻せません。",
      preview: "取り込む図",
      processIdChanged:
        "実行プロセスが {{from}} から {{to}} に変わります。モデルの設定（primary_process_id）も合わせて更新されます。",
      processIdSet:
        "実行プロセスを {{to}} に設定します。モデルの設定（primary_process_id）も合わせて更新されます。",
      previewFailed:
        "この図は画面に表示できません（レイアウト情報が無いか壊れています）。差し替えるとこの画面で表示も編集もできなくなるため、別のファイルを選んでください。",
      submit: "差し替える",
      cancel: "やめる",
      failed: "図を差し替えられませんでした。",
      forbidden: "差し替える権限がありません。",
      fileInvalid: "BPMN を受け付けられませんでした: {{detail}}",
      restoreFailed:
        "図を差し替えられませんでした。実行プロセスの設定を元に戻せなかった可能性があります。画面を読み直し、実行プロセスを確かめてください。",
    },
    importForms: {
      open: "ファイルを取り込む",
      title: "フォーム定義の取り込み",
      description:
        "選んだ .json を、その名前のままこのモデルに置きます。同じ名前のフォーム定義があれば上書きします（元の内容は画面からは戻せません）。",
      fileLabel: "フォーム定義のファイル",
      fileHint:
        ".json を複数選べます（*-schema.json / *-uischema.json。区切りは . も可）。",
      selected: "取り込むファイル",
      create: "新規",
      overwrite: "上書き",
      remove: "{{name}} を外す",
      submit: "取り込む",
      cancel: "やめる",
      issueBpmn:
        "図（.bpmn）は、フロー図の「取り込み」から差し替えてください。",
      issueNotJson: ".json ファイルを選んでください。",
      issueDuplicate: "同じ名前のファイルを 2 回選んでいます。",
      failed: "{{name}} を取り込めませんでした。",
      forbidden: "{{name}} を取り込む権限がありません。",
      fileInvalid: "{{name}} を受け付けられませんでした: {{detail}}",
      imported: "{{names}} は取り込みました。",
      remaining: "{{names}} はまだ取り込んでいません。",
      nameSeparator: "、",
    },
    remove: {
      model: "モデルを削除",
      group: "削除",
      groupLabel: "グループ「{{name}}」を削除",
      confirmModel:
        "モデル「{{name}}」（{{id}}）を削除しますか？ 案件が 1 件でもあると削除できません。",
      confirmGroup: "グループ「{{name}}」（{{id}}）を削除しますか？",
      submit: "削除する",
      cancel: "やめる",
      hasInstances: "案件があるため削除できません。",
      forbidden: "削除する権限がありません。",
      notEmpty:
        "このグループにはモデルがあるため削除できません（一覧を読み直しました）。",
      failed: "削除できませんでした。",
    },
  },
  activityLog: {
    title: "操作履歴",
    description: "直近の案件を横断して、誰がいつどの操作をしたかを確認します。",
    scopeNote:
      "直近 {{count}} 件の案件を対象にしています（横断で履歴を取る API が無いため案件ごとに取得）。承認と差し戻しの区別は履歴に残らないため、内訳は案件詳細で確認してください。",
    partial:
      "{{count}} 件の案件は履歴を取得できませんでした（権限または通信エラー）。",
    occurredAt: "日時",
    actor: "実行者",
    step: "操作",
    filterActor: "実行者",
    filterFrom: "開始日",
    filterTo: "終了日",
    empty: "対象の操作履歴はありません",
  },
  taskRun: {
    title: "内容の入力",
    back: "マイ案件へ戻る",
    notAvailable:
      "この入力画面は開けません（すでに提出済み、または権限がありません）。",
    missingForm:
      "このタスクにフォームが設定されていないため開けません。プロセス設計でフォームを紐付けてください。",
  },
  permissions: {
    title: "所属と権限",
    description: "自分の所属グループと BPM 操作権限を確認します。",
    myGroups: "所属グループ",
    noGroups: "所属グループがありません",
    myPermissions: "BPM 操作権限",
    allowed: "許可",
    denied: "不可",
    sotNote:
      "所属の正本は Zeus IdP（OIDC claim）、操作ポリシーは zeus.yml です。メンバーの追加・削除は IdP 側で行います。",
    targets: {
      caseListMine: "自分の案件の閲覧",
      caseListAll: "全案件の閲覧",
      taskList: "承認タスクの閲覧",
      processModelRead: "案件種別の閲覧",
      processModelWrite: "プロセス設計（作成・編集）",
      secretList: "Secrets の閲覧",
      userSearch: "ユーザー検索",
    },
  },
  allCases: {
    title: "全案件モニタ",
    description: "全プロセスインスタンスの状態と滞留を横断監視します。",
    kpi: {
      inProgress: "進行中",
      stuck: "滞留（5営業日超）",
      returned: "差し戻し中",
      completed: "完了（直近）",
    },
    elapsed: "経過",
    businessDays: "{{count}} 営業日",
    empty: "該当する案件はありません",
  },
  notifications: {
    title: "通知",
    description: "承認依頼・差し戻し・完了のお知らせ。",
    markAllRead: "すべて既読にする",
    empty: "通知はありません",
    unread: "未読",
    kinds: {
      approvalRequested: "承認依頼",
      returned: "差し戻し",
      completed: "完了",
    },
    fromApplicant: "{{name}} さんから承認が依頼されています",
  },
  home: {
    title: "ホーム",
    // カード行の小見出し。h1 で「やること」と言い切らない（完了・最近の案件も並ぶため）
    actionNeeded: "対応が必要なこと",
    cards: {
      pendingApprovals: "承認待ち（あなた宛）",
      draft: "下書き",
      returned: "差し戻し（要対応）",
      completed: "完了（直近）",
    },
    recent: "最近の案件",
    allClear: "対応が必要な案件はありません",
  },
  approvals: {
    pending: "承認待ち",
    history: "承認済み",
    requestedAt: "承認依頼日",
    /** 行のボタン。開くだけで承認はしない（承認は判定画面と一括承認） */
    review: "内容を確認",
    back: "承認リクエストへ戻る",
    requestContent: "申請内容",
    openCase: "案件の詳細を開く",
    notAvailable:
      "この承認は開けません（すでに処理済み、または権限がありません）。",
    missingForm:
      "このタスクにフォームが設定されていないため開けません。プロセス設計でフォームを紐付けてください。",
    approve: "承認",
    reject: "差し戻し",
    rejectReason: "差し戻しの理由",
    rejectReasonRequired: "理由を入力してください",
    approved: "承認しました",
    rejected: "差し戻しました",
    empty: "承認待ちの案件はありません",
    historyEmpty: "承認履歴はありません",
    selectAll: "すべて選択",
    bulkApprove: "選択した案件を承認",
    bulkResult: "{{approved}} 件を承認しました",
    bulkSkipped: "{{count}} 件は個別に確認が必要です",
    bulkFailed: "{{count}} 件が失敗しました",
  },
  savedViews: {
    label: "ビュー",
    save: "この条件を保存",
    namePrompt: "ビューの名前",
    delete: "削除",
    empty: "保存したビューはありません",
  },
  newApplication: {
    title: "新規作成",
    description: "起票する案件種別を選んでください。",
    noRunnable: "起票できる案件種別がありません。",
    searchTypes: "案件種別を検索",
    noMatch: "該当する案件種別がありません。",
    back: "マイ案件へ戻る",
    submit: "提出する",
    saveDraft: "下書き保存",
    submitted: "提出しました",
    draftSaved: "下書きを保存しました",
    submitFailed: "提出に失敗しました",
    noForm: "この案件種別には入力フォームがありません。",
    typeDetail: {
      create: "この種別で作成",
      back: "新規作成へ戻る",
      unknown: "この案件種別が見つかりません。",
      createFailed: "案件を作成できませんでした。",
      createForbidden: "この操作を行う権限がありません。",
      createModelInvalid:
        "このモデルの BPMN に実行できない箇所があります。プロセス設計で図を見直してください。",
      createErrorElement: "原因の要素（id）: {{id}}",
      createdCaseStopped:
        "案件 #{{id}} は作成されましたが、エラーで止まっています。",
      createdCaseOpen:
        "案件 #{{id}} は作成されました。入力画面は案件から開いてください。",
      openCase: "案件を開く",
      createRetry:
        "マイ案件に作成されていないか確認してから、再度お試しください。",
      createDetail: "詳細",
      createErrorMeta: "段階: {{stage}} / error_code: {{code}}",
      createErrorStage: "段階: {{stage}}",
      stage: {
        create: "作成",
        run: "実行",
        tasks: "タスクの取得",
      },
      hint: "内容を確認してから作成してください。作成すると下書きの案件ができます。",
    },
    scopedStart: {
      description: "承認者と申請部署は組織構造から自動で決まります。",
      unknownModel: "この案件種別は起票できません（設定が見つかりません）。",
      noApprovers:
        "承認者が見つかりませんでした。組織の設定を管理者に確認してください。",
      resolutionFailed:
        "組織情報を取得できませんでした。時間をおいて試してください。",
      notConfigured:
        "起票の口が設定されていません（管理者に確認してください）。",
      failed: "起票に失敗しました。",
    },
  },
  processOverview: {
    title: "プロセス全体",
    legendCurrent: "現在地",
    legendCompleted: "完了",
    legendError: "エラー",
    unavailable: "プロセス図を表示できませんでした。",
  },
  /** 戻るリンク。宛先の名前を差し替えて使う（ナビの表示名を再利用する）。 */
  backTo: "{{name}}へ戻る",
  /** ナビに無い戻り先の呼び名。 */
  backTargets: {
    approvalReview: "この承認",
  },
  caseDetail: {
    decidedBy: "判定者",
    forbidden:
      "この案件を開く権限がありません。全案件の閲覧は管理者に依頼してください。",
    title: "案件の詳細",
    back: "マイ案件へ戻る",
    notFound: "この案件を開けません（URL が正しくありません）。",
    diagramUnavailable: "フロー図を表示できませんでした。",
    sections: {
      summary: "概要",
      process: "プロセスの説明",
      history: "履歴",
    },
    caseContent: "この案件の内容",
    /** 詳細ページの操作パネル（自分の番のときだけ出す）。 */
    action: {
      next: "次の承認へ（{{name}}）",
      title: "この案件への対応",
      review: "承認する",
      draft: "修正して再提出",
      reviewNote: "この案件はいま自分の判断待ちです。",
      draftNote: "内容を直してもう一度提出できます。",
      formMissing:
        "このタスクにフォームが設定されていないため、ここでは操作できません。プロセス設計でフォームを紐付けてください。",
      submitFailed: "送信に失敗しました。時間をおいて再試行してください。",
    },
    returnedReason: "差し戻し理由",
    returnedReasonEmpty: "理由の記入がありません。",
    processDescriptionNote: "この案件種別に共通の説明です。",
    initiator: "起票者",
    startedAt: "起票日時",
    endedAt: "完了日時",
    businessData: "入力内容",
    noHistory: "履歴がありません",
    diagram: "フロー図",
    saveDiagram: "保存",
    saveFailed: "保存に失敗しました",
    saved: "保存しました",
    eventTypes: {
      task_completed: "完了",
      task_cancelled: "取消",
      process_instance_rewound_to_task: "巻き戻し",
      task_data_edited: "データ編集",
      task_executed_manually: "手動実行",
      task_skipped: "スキップ",
      process_instance_error: "エラー",
      process_instance_force_run: "強制実行",
      process_instance_migrated: "版移行",
      process_instance_resumed: "再開",
      process_instance_suspended: "一時停止",
      process_instance_terminated: "中止",
    },
  },
  placeholderPage: {
    title: "準備中",
    description: "この画面はまだ実装されていません。",
  },
  notFound: {
    title: "ページが見つかりません",
    description: "URL をご確認ください。",
    backToHome: "ホームへ戻る",
  },
} as const;
